export function isVerifiedBlendataAffiliation(affiliation) {
  return Boolean(
    affiliation &&
    typeof affiliation === 'object' &&
    affiliation.isActive === true &&
    affiliation.type === 'organization' &&
    affiliation.sourceSystem === 'blendata' &&
    typeof affiliation.externalSourceKey === 'string' &&
    affiliation.externalSourceKey.trim() !== ''
  )
}

export function getVerifiedBlendataAffiliationName(affiliation, fallback = '') {
  if (!isVerifiedBlendataAffiliation(affiliation)) return fallback
  return affiliation.name || affiliation.code || fallback
}
